import formName from 'constants/formName'
import { actions } from 'data'
import { TwoFactorStepType } from 'data/types'
import { put } from 'redux-saga/effects'

export const goToStep = function* (step: TwoFactorStepType) {
  yield put(actions.form.change(formName.TWO_FACTOR, 'step', step))
}
